module.exports = __webpack_public_path__ + "img/Group_27919.7cfcbbb4.png";